import React from 'react';
import { FlexView, COLORS, Row, Col } from '@cuemath/comps';
import { Button, Separator, Text, TextInput } from '@cuemath/web-comps';
import styled from 'styled-components';
import LAYOUT from 'constants/layout';

import { Close } from 'styled-icons/material/Close';
import useLogic from './AutoMappingForm.logic';
import PropTypes from 'prop-types';
import MappingFilters from '../mapping-filters';

const DateTimePickerWrapper = styled(FlexView)`
  position: relative;
  flex: 1;
  border: 1px solid ${COLORS.GREY_SHADE};
  border-radius: 8px;
`;

const DateTimePicker = styled(FlexView)`
  :last-child {
    margin-bottom: ${LAYOUT.GUTTER}px;
  }
`;

const DeleteIcon = styled(Close)`
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin-top: 12px;
`;

const SelectorGroup = styled(Row)`
  margin: 0 -8px;
`;

const { GUTTER, GAP } = LAYOUT;

const AutoMappingForm = ({ handleSubmit, submitLoader }) => {
  const {
    handleChange,
    showAddSlotButton,
    handleAddNewSlot,
    handleRemoveSlot,
    dateTimePreset,
    prospectId,
    handleSubmit̨MappingSearch,
    enableSubmit,
    filters,
    handleFilterChange,
  } = useLogic({ handleSubmit });

  return (
    <FlexView inherit>
      <TextInput
        value={prospectId}
        onChange={value => handleChange({ key: 'prospectId', value })}
        label="Prospect ID"
      />
      <MappingFilters filters={filters} handleChange={handleFilterChange} />
      <DateTimePickerWrapper gutter={GUTTER} gap={GAP}>
        <FlexView flexDirection="row" justifyContent="space-between">
          <Text variant="h6">Date and time</Text>
        </FlexView>
        <Separator height={24} />
        {dateTimePreset?.map(({ date, time, id }) => (
          <DateTimePicker key={id}>
            <SelectorGroup gutter={0} flexDirection="row">
              <Col gutter={8} auto>
                <TextInput
                  type="date"
                  label="Select date"
                  value={date}
                  onChange={value => handleChange({ key: 'date', value, id })}
                />
              </Col>
              <Col gutter={8} auto>
                <TextInput
                  type="time"
                  label="Select time"
                  value={time}
                  onChange={value => handleChange({ key: 'time', value, id })}
                />
              </Col>
              <Col gutter={2}>
                {dateTimePreset?.length > 1 && (
                  <DeleteIcon alt="delete" onClick={() => handleRemoveSlot(id)} />
                )}
              </Col>
            </SelectorGroup>
          </DateTimePicker>
        ))}
        {showAddSlotButton && (
          <>
            <Button
              variant="secondary"
              label="+ Add another time slot"
              size="xsmall"
              onClick={handleAddNewSlot}
            />
          </>
        )}
      </DateTimePickerWrapper>
      <Separator height={GUTTER} />
      <FlexView alignItems="center">
        <Button
          isBusy={submitLoader}
          label="Search teacher"
          size="small"
          onClick={handleSubmit̨MappingSearch}
          isDisabled={!enableSubmit}
        />
      </FlexView>
    </FlexView>
  );
};

AutoMappingForm.propsTypes = {
  handleSubmit: PropTypes.func,
  submitLoader: PropTypes.bool,
};

export default AutoMappingForm;
